import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';

import {
  RsaSearchFinalUrlInitModel,
  RsaSearchFinalUrlInitVariables,
  RsaSearchFinalUrlModel,
  RsaSearchFinalUrlVariables,
} from '../../../../../models/google-template/rsa-search-final-url.interface';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-rsa-search-final-url',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './rsa-search-final-url.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './rsa-search-final-url.component.scss'
})
export class GoogleRsaSearchFinalUrlComponent extends BaseComponent implements OnInit {
  //@ input
  @Input() block: RsaSearchFinalUrlModel = new RsaSearchFinalUrlInitModel();
  @Input() isPreview = false;
  //@ output
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new RsaSearchFinalUrlInitVariables()
    }
  }

  //@ placeholders
  linkPlaceholder: string = 'Enter final URL';

  //@remove
  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  //@onChange
  onChange(value: any, fieldName: keyof RsaSearchFinalUrlVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof RsaSearchFinalUrlVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
